/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TdxService {
    /**
     * @param iataNo
     * @param flightNo
     * @param checkDate
     * @param isInternational
     * @returns any OK
     * @throws ApiError
     */
    public static getApiTdxQueryFlightSchedule(
        iataNo?: string,
        flightNo?: string,
        checkDate?: string,
        isInternational?: boolean,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/TDX/QueryFlightSchedule',
            query: {
                'IataNo': iataNo,
                'flightNo': flightNo,
                'checkDate': checkDate,
                'isInternational': isInternational,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getApiTdxAirlines(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/TDX/Airlines',
        });
    }
    /**
     * @param airportCode
     * @returns any OK
     * @throws ApiError
     */
    public static getApiTdxFlightDepartureInfo(
        airportCode?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/TDX/FlightDepartureInfo',
            query: {
                'airportCode': airportCode,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param airportCode
     * @returns any OK
     * @throws ApiError
     */
    public static getApiTdxFlightArrivalInfo(
        airportCode?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/TDX/FlightArrivalInfo',
            query: {
                'airportCode': airportCode,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
